
import React from 'react';
import { componentMap } from './componentMap';
import { moduleThemes } from './moduleThemes'; // 👈 NEW: Import your theme map
import { SearchTabProvider } from './SearchTabContext';
import WhatsAppButton from './WhatsAppButton/WhatsAppButton';

function WebsiteRenderer({ 
  layout, branding, companyId, destinations, heroData, headerMenu, footerData,
  mode = "live", viewState = { name: 'home', params: null }, onNavigate,
  templateId, aboutData, contactData, styleConfig 
}) {

  if (!layout) return <div>Loading...</div>;

  // 1. MAPPING CORE COMPONENTS
  const TopBar = componentMap[layout.topBar];
  const Header = componentMap[layout.header];
  const Footer = componentMap[layout.footer];

  // Helper object to easily pass all common props to the dynamic pages
  const commonProps = {
    companyId, destinations, branding, contactData, mode, onNavigate, templateId, params: viewState.params,  styleConfig
  };

  // 2. DYNAMIC PAGE RESOLVER
  const renderBody = () => {
    switch (viewState.name) {
      case 'home':
        // 👇 NEW: If B2C mode, and we have an "active" module (like flights), 
        // we can optionally redirect to that module's page, OR render it here.
        
        // Let's check if the Admin has picked a specific default "landing" module
        // For now, let's keep the standard Home components, 
        // BUT we make sure they only render if they are part of the active modules.
        
        const Hero = componentMap[layout.hero];
        const HomeDestinations = componentMap[layout.destinations];
        const HomePackages = componentMap[layout.packages];
        const AboutComponent = componentMap[layout.aboutUs];
      
        return (
          <>
            {/* If it's a B2C site, you might want to hide the standard Hero/Packages 
                if you prefer a clean Search-only landing page. */}
            {Hero && <Hero branding={branding} heroData={heroData} />}
            
            {/* Only show these if the module is enabled/selected */}
            {HomeDestinations && layout.destinations !== "None" && <HomeDestinations destinations={destinations} />}
            
            {HomePackages && layout.packages !== "None" && (
                <HomePackages companyId={companyId} mode={mode} onNavigate={onNavigate} templateId={templateId} />
            )}
            
            {AboutComponent && layout.aboutUs !== "None" && <AboutComponent aboutData={aboutData} />}
          </>
        );
       case 'about':
        const DedicatedAbout = componentMap[layout.aboutUs];
        return DedicatedAbout && layout.aboutUs !== "None" ? 
            <div style={{paddingTop: '80px'}}><DedicatedAbout aboutData={aboutData} /></div> : 
            <div style={{padding: '100px', textAlign: 'center'}}>About Us section not selected.</div>;

      case 'package-details':
        const DetailsPage = componentMap[layout.detailsPage || 'PackageDetails1'];
        return <DetailsPage packageId={viewState.params?.packageId} mode={mode} onNavigate={onNavigate} />;

      // =====================================
      // ✈️ NEW: FLIGHT MODULE THEME ROUTING
      // =====================================
      case 'flights': // matches the header link "/flights"
      case 'flight-search': {
        // Fallback to layout.flightsPage just in case you haven't updated your CreateTemplate state yet
        const themeToUse = layout.flightTheme || layout.flightsPage;
        const FlightSearchPage = moduleThemes.flights?.[themeToUse]?.search;
        return FlightSearchPage ? <FlightSearchPage {...commonProps} /> : <div style={{padding: '100px', textAlign: 'center'}}>Flight Search design not selected.</div>;
      }

      case 'flight-results': {
        const themeToUse = layout.flightTheme || layout.flightsPage;
        const FlightResultsPage = moduleThemes.flights?.[themeToUse]?.results;
        return FlightResultsPage ? <FlightResultsPage {...commonProps} /> : <div style={{padding: '100px', textAlign: 'center'}}>Flight Results design not selected.</div>;
      }

      case 'flight-details': {
        const themeToUse = layout.flightTheme || layout.flightsPage;
        const FlightDetailsPage = moduleThemes.flights?.[themeToUse]?.details;
        return FlightDetailsPage ? <FlightDetailsPage {...commonProps} /> : <div style={{padding: '100px', textAlign: 'center'}}>Flight Details design not selected.</div>;
      }
       case 'flight-review': {
        const themeToUse = layout.flightTheme || layout.flightsPage;
        const FlightReviewPage = moduleThemes.flights?.[themeToUse]?.review;
        return FlightReviewPage ? <FlightReviewPage {...commonProps} /> : <div>Review design not selected.</div>;
      }

      // 👇 ADD THIS CASE FOR CONFIRMATION
      case 'flight-confirmation': {
        const themeToUse = layout.flightTheme || layout.flightsPage;
        const FlightConfirmationPage = moduleThemes.flights?.[themeToUse]?.confirmation;
        return FlightConfirmationPage ? <FlightConfirmationPage {...commonProps} /> : <div>Flight Confirmation design not selected.</div>;
      }
     case 'buses': 
case 'bus-search': {
  const themeToUse = layout.busTheme;
  const BusSearchPage = moduleThemes.buses?.[themeToUse]?.search;
  return BusSearchPage ? <BusSearchPage {...commonProps} /> : <div>Bus Search design not selected.</div>;
}

case 'bus-results': {
  const themeToUse = layout.busTheme;
  const BusResultsPage = moduleThemes.buses?.[themeToUse]?.results;
  return BusResultsPage ? <BusResultsPage {...commonProps} /> : <div>Bus Results design not selected.</div>;
}

case 'bus-seats': {
  const themeToUse = layout.busTheme;
  const BusSeatsPage = moduleThemes.buses?.[themeToUse]?.seats;
  return BusSeatsPage ? <BusSeatsPage {...commonProps} /> : <div>Bus Seats design not selected.</div>;
}

case 'bus-payment': {
  const themeToUse = layout.busTheme;
  const BusPaymentPage = moduleThemes.buses?.[themeToUse]?.payment;
  return BusPaymentPage ? <BusPaymentPage {...commonProps} /> : <div>Bus Payment design not selected.</div>;
}
  case 'bus-booking-confirmation': {
        const themeToUse = layout.busTheme;
        const BusConfirmationPage = moduleThemes.buses?.[themeToUse]?.confirmation;
        return BusConfirmationPage ? <BusConfirmationPage {...commonProps} /> : <div>Bus Confirmation design not selected.</div>;
      }
      

      // Add 'bus-details' or 'bus-seats' here later when you build it
      // case 'bus-seats': { ... }
       case 'hotels': {
        const themeToUse = layout.hotelTheme;
        const HotelSearchPage = moduleThemes.hotels?.[themeToUse]?.search;
        return HotelSearchPage ? <HotelSearchPage {...commonProps} /> : <div style={{padding: '100px', textAlign: 'center'}}>Hotel Search design not selected.</div>;
      }
      // =====================================
      // DEFAULT: SINGLE PAGE COMPONENTS
      // =====================================
      default:
        /** 
         * For ANY other page (packages, destinations, visas, buses):
         * Example: viewState.name 'visas' -> looks for layout.visasPage
         */
        const pageKey = `${viewState.name}Page`; 
        const DynamicPageComponent = componentMap[layout[pageKey]];

        if (DynamicPageComponent) {
          return (
            <DynamicPageComponent {...commonProps} />
          );
        }
        
        return <div style={{padding: '100px', textAlign: 'center'}}>Page {viewState.name} design not selected.</div>;
    }
  };

  // 3. THE MASTER WRAPPER
  return (
    <div className="page-wrapper">
      {/* TopBar */}
      {TopBar && layout.topBar !== "None" && <TopBar branding={branding} companyId={companyId} />}

      <SearchTabProvider>
        {/* Header */}
        {Header && (
          <Header 
            branding={branding} 
            headerMenu={headerMenu} 
            mode={mode} 
            onNavigate={onNavigate} 
            templateId={templateId} 
          />
        )}

        {/* BODY */}
        <main style={{ minHeight: '80vh' }}>
          {renderBody()}
        </main>
      </SearchTabProvider>

      {/* Footer */}
      {Footer && (
        <Footer 
          branding={branding} 
          companyId={companyId} 
          footerData={footerData} 
          headerMenu={headerMenu}
          onNavigate={onNavigate} 
          mode={mode}
          templateId={templateId} 
        />
      )}
      <WhatsAppButton branding={branding} />
    </div>
  );
}

export default WebsiteRenderer;